import { render, staticRenderFns } from "./AdminNotesComponent.vue?vue&type=template&id=e57a0f74"
import script from "./AdminNotesComponent.vue?vue&type=script&lang=js"
export * from "./AdminNotesComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports